import React, { useEffect, useState } from "react";
import { BackButton, Heading, Input, Button } from "../../components/Common";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Grid, Stack, IconButton, Typography } from "@mui/material";
import {
  LanguageCreate,
  LanguageUpdate,
  LanguageDetail,
} from "../../Service/Language.service";
import { useFormik } from "formik";
import { languageInitialValues } from "../../helper/initialValues";
import { languageValidationSchema } from "../../helper/validation";
import { useLocation, useNavigate } from "react-router-dom";
import { notificationSuccess } from "../../state/Action/NotificationAction";
import { useDispatch } from "react-redux";

const AddLanguage = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: languageInitialValues,
    onSubmit: async (value) => {
      const payload = {
        languageName: value.languageName,
        languageSlug: value.languageSlug,
        languageCode: value.languageCode,
      };

      let res = isEdit
        ? await LanguageUpdate(editId, payload)
        : await LanguageCreate(payload);
      if (res?.status) {
        dispatch(
          notificationSuccess({
            show: true,
            type: "success",
            message: res.message || "Success",
          })
        );
        formik.resetForm();
        navigate("/language");
      } else {
        dispatch(
          notificationSuccess({
            show: true,
            type: "error",
            message:
              res.message || "Something went wrong. Please try again later.",
          })
        );
      }
    },
    validationSchema: languageValidationSchema,
  });

  useEffect(() => {
    if (state && state?.isEdit && state?.id) {
      setIsEdit(true);
      setEditId(state.id);
      getLanguageDetails(state.id);
    } else {
      setEditId(null);
      setIsEdit(false);
    }
  }, [state]);

  const getLanguageDetails = async (id) => {
    let res = await LanguageDetail(id);
    if (res?.status) {
      formik.setValues({
        languageName: res.data.languageName,
        languageSlug: res.data.languageSlug,
        languageCode: res.data.languageCode,
      });
    }
  };

  return (
    <>
      <Stack gap={2} mt={1}>
        <Stack
          mb={1}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Stack
            flexDirection={"row"}
            justifyContent={"flex-start"}
            gap={1}
            alignItems={"center"}
          >
            <BackButton />
            <Heading head={`${isEdit ? "Edit Language" : "Add Language"}`} />
          </Stack>
        </Stack>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Input
                labelinput={"Language Name"}
                name="languageName"
                formik={formik}
                maxLength={50}
              />
              <Typography variant="caption" sx={{ mt: 0.5, color: 'text.secondary', display: 'block' }}>
                Note : Language Name like this "English"
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                labelinput={"Language Slug"}
                name="languageSlug"
                formik={formik}
                maxLength={50}
              />
              <Typography variant="caption" sx={{ mt: 0.5, color: 'text.secondary', display: 'block' }}>
                Note : Language Slug like this "english"
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                labelinput={"Language Code"}
                name="languageCode"
                formik={formik}
                maxLength={20}
                iconinput={<HelpOutlineIcon onClick={() => window.open('https://docs.cloud.google.com/speech-to-text/docs/v1/speech-to-text-supported-languages', '_blank')} style={{ cursor: 'pointer' }} />}
                onChange={(e) => {
                  const updated = e.target.value.replace(/-/g, '_');
                  formik.setFieldValue('languageCode', updated);
                }}
              />
              <Typography variant="caption" sx={{ mt: 0.5, color: 'text.secondary', display: 'block' }}>
                Note : Language Codes like this "en_US"
              </Typography>
            </Grid>
          </Grid>
        </div>
        <Stack flexDirection={"row"} mt={2} gap={1}>
          <Button
            buttonName="Cancel"
            size="small"
            color="white"
            onClick={() => navigate("/language")}
          />
          <Button
            buttonName={`${isEdit ? "Update" : "Create"}`}
            size="small"
            onClick={formik.handleSubmit}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default AddLanguage;
